import React, { useEffect, useState } from 'react'
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  Label,
  Row
} from "reactstrap";
import Breadcrumb from 'Components/UI/Breadcrumb';
import Dropzone from 'Components/Form/DropZone';
import placeholderImage from "assets/images/img.png";
import { getAdminSettings, updatePublicAdminSettings, uploadImage } from 'helpers/API Calls/System & Settings/Admin Settings';
import Spinner from 'Components/UI/Spinner';
import ConformationModal from 'Components/Modals/ConformationModal';
import { set } from 'lodash';

function Home() {
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [image, setImage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [modal, setModal] = useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
        setIsLoading(true);
        const response = await getAdminSettings('key=HERO_IMAGE');
        if(response.success) {
            const imageUrl = response.data[0]?.value || null;
            setImage(imageUrl);
        } 
        setIsLoading(false);       
    }
    fetchData(); 
  }, [])


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;
    
    const formData = new FormData();
    if (selectedImage) {
      formData.append("file", selectedImage);
      setIsSubmitting(true);
      const response = await uploadImage(formData);
      if (response) {
        const data = {
          settings : [
            { key: "HERO_IMAGE", value: response.url, id: 25 }
          ]
        }
        const settingResponse = await updatePublicAdminSettings(data);
        if (settingResponse.success) {
          setImage(response.url);
          setSelectedImage(null);
        }
      }
      setIsSubmitting(false);
    }

  };

  const handleResetLayout = async () => {
    setIsSubmitting(true);
      const data = {
        settings : [
          { key: "LAYOUT", value: null, id: 23 }
        ]
      }
      const settingResponse = await updatePublicAdminSettings(data);
      if (settingResponse.success) {
        setModal(false);
      }
    setIsSubmitting(false);
  }


  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb items={[{ label: "Home Page"}]} />
          {isLoading ? <div className="position-relative vh-100"><Spinner/></div>
          :
          <Card>
            <CardBody>
              <CardTitle tag="h4" className='mb-4'>Home Page Hero Image</CardTitle>
              <Form onSubmit={handleSubmit} autoComplete="off">
                <Row>
                  <Col>
                    <div className="mb-3" id="hero-image-section">
                      <Label htmlFor="hero-image">Hero Image</Label>
                      <Dropzone
                        accept={{ "image/*": [".png", ".jpeg", ".jpg"] }}
                        onDrop={(acceptedFiles) => {
                          setSelectedImage(acceptedFiles[0]);
                        }}
                        onDelete={() => {
                          setSelectedImage(null);
                          setImage(null);
                        }}
                        showDelete={false}
                        renderContent={() => (
                          <div className="text-center cursor-pointer">
                            <div className="position-relative d-inline-block">
                              <div className="avatar-xl rounded">
                                <div className="avatar-title bg-light">
                                  <img
                                    src={
                                      selectedImage
                                        ? URL.createObjectURL(selectedImage)
                                        : image || placeholderImage
                                    }
                                    alt="Hero"
                                    className="avatar-xl rounded"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      />
                    </div>
                  </Col>
                </Row>

                <div className="d-flex flex-wrap gap-2 mt-3 justify-content-end">
                  <Button type="submit" color="primary" disabled={isSubmitting || (!selectedImage && !image)}>
                    {isSubmitting ? 'Updating...' : 'Update'}
                  </Button>
                  

                </div>
              </Form>
            </CardBody>
          </Card>
        }
        <Card>
          <CardBody>
            <CardTitle tag="h4">Reset Home Page Layout</CardTitle>
            {/* <Label htmlFor="hero-image">Hero Image</Label> */}
             <p className="text-muted mb-4">
              Restore the home page layout to its default settings. This will remove any custom layout changes you've made. You can re-apply your preferences anytime.
            </p>

            <Button
              type="button"
              color="success"
              onClick={() => {setModal(true);}}
              disabled={isSubmitting}
            >
              Reset Home Page Layout
            </Button>
          </CardBody>
        </Card>
        </Container>
      </div>
      {modal && 
        <ConformationModal
          show={modal}
          onConfirmClick={handleResetLayout}
          onCloseClick={() => setModal(false)}
          message={'reset home page layout?'}
          textAfter={'You can choose a different layout from user end'}
          buttonText= {'Reset'}
        />}
    </>
  );
}

export default Home;
